const content  = {
    EN: {
      ID: 'Item No.',  
      Description: 'Description',
      SampleDescription: 'Sample Description',
      Inventory: 'Inventory',
      SpecialWeight: 'Special Weight',
      Composition: 'Composition',
      Width: 'Width',
      UnitPrice: 'Unit Price',
    },
    GR: {
        ID: 'Κωδικός',
        Description: 'Περιγραφή',
        SampleDescription: 'Συντομ/φία Δείγατος',
        Inventory: 'Απόθεμα',
        SpecialWeight: 'Ειδικό Βάρος',
        Composition: 'Σύνθεση',
        Width: 'Πλάτος',
        UnitPrice: 'Τιμή Μονάδας',
    },
  };

  export default content;


// WEBPACK FOOTER //
// ./src/components/itemlist/content.js